"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var colorText = _a.colorText,
      colorBg = _a.colorBg,
      colorPrimary = _a.colorPrimary,
      x10 = _a.x10,
      x8 = _a.x8,
      x4 = _a.x4,
      x1 = _a.x1;
  return {
    navigationItem: {
      height: x10,
      '&:hover, &$hover': {
        background: colorBg.hover,
        cursor: 'pointer'
      },
      '& a': {
        textDecoration: 'none'
      }
    },
    navigationItemBody: {
      height: '100%',
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: x4,
      paddingLeft: x4,
      display: 'flex',
      alignItems: 'center',
      position: 'relative'
    },
    text: {
      color: colorText.normal,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    active: {
      '& $text': {
        color: colorPrimary.normal
      },
      '& $borderRight': {
        width: 3,
        height: x8,
        backgroundColor: colorPrimary.normal,
        position: 'absolute',
        right: 0,
        top: x1,
        display: 'block'
      }
    },
    borderRight: {
      display: 'none'
    },
    hover: {}
  };
};